// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"421":"25d97217","946":"d4f6a9cd"}[chunkId] + ".chunk.js";
};